import { StatusTag } from '@cogneed/design-system';
import { TFunction } from 'i18next';
import { ComplianceChecklistItemStatus } from '../../../generated/core-api/graphql-react-query';

// Shared status -> {color, label} mapping for a compliance item, used by
// both the standalone item card (pending items) and the processed group's
// rows (validated/rejected items) so the two contexts never drift.
export default function complianceStatusTag(result: ComplianceChecklistItemStatus, t: TFunction) {
  if (result === ComplianceChecklistItemStatus.Validated) {
    return <StatusTag color="success" label={t('home-page.compliance.mandatory.state.Validated')} />;
  }
  if (result === ComplianceChecklistItemStatus.Rejected) {
    return <StatusTag color="error" label={t('home-page.compliance.mandatory.state.Rejected')} />;
  }
  return <StatusTag color="warning" label={t('right-panel.session-compliance.card.pendingStatus')} />;
}
